<script setup lang="ts">
import type {PageInterface} from "~~/server/types/page";
import { computed } from "vue";

const ContactFormComponent=defineAsyncComponent(() => import('~/components/ContactFormComponent.vue'));
const SectionComponent=defineAsyncComponent(()=>import('~/components/SectionsComponent.vue'))
const route = useRoute()
const { $api } = useNuxtApp()
const { locale } = useI18n();
const slug = computed(() => route.params.slug);

const key_page_slug = computed(
  () => "page:" + slug.value + ":" + locale.value,
);
const { data:page, error } = await useAsyncData(
  key_page_slug.value,
    () => $api<PageInterface>(`page/${slug.value}`)
)
if (error.value) showError(error.value);

usePageSeo({...page.value!,schemaType: 'website'});
</script>

<template>
    <SectionComponent v-if="page?.section" :section="page?.section" />
    <section class="container-xxl">
      <h1 v-if="!page?.section" class="section_title mb-4">{{ page?.name }}</h1>
      <div class="content" v-html="page?.description"></div>
      <ClientOnly>
        <contact-form-component v-if="route.params.slug==='contact'" />
      </ClientOnly>
    </section>
</template>
